module.exports = __webpack_public_path__ + "static/media/home_mobile_bg.fdc1f7bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_mobile_bg.png
// module id = 119
// module chunks = 0